<template>
    <div>
        <div class="container">
            <div>
                <h2 v-translate>Conditions de la visite</h2>
                <ol>
                    <li>Carte d'accès obligatoire</li>
                    <li>Port d'une protection nasale et buccale</li>
                    <li>Tri au préalable</li>
                    <li>Temps de déchargement limité à 30min</li>
                    <li>Respecter le règlement intérieur</li>
                </ol>
            </div>
            <div>
                <h2 v-translate>Règles de comportement</h2>
                <ol>
                    <li>S'aligner dans la voie désignée pour rendez-vous</li>
                    <li>Présenter une carte d'accès active</li>
                    <li>Présenter une confirmation de réservation</li>
                </ol>
            </div>
        </div>
        <div class="box">
            <div class="box__highlight">
                <img src="../assets/ui/exclamation.svg" class="exclamation" alt="">
            </div>
            <div class="box__content">
                <h2 v-translate>Restrictions et conditions</h2>
                <p>Les quantités pour les particuliers sont acceptées dans les quantités normalement produites par un ménage. La limite par visite est de 1m³ / ménage pour les fractions de déchets solides et 30 litres en volume pour les fractions de déchets liquides. Le temps de déchargement est limité à 30min.</p>
                <a href="http://www.sivec.lu/reglement-interieur/" target="_blank" v-translate>Réglement intérieur, conditions de la visite et règles de comportement</a>
                <div v-if="this.$store.state.email !== ''" class="box__content__checkbox">
                    <input v-on:change="checkNewsletter" v-model="newsletter" type="checkbox" id="newsletter"><label for="newsletter"><img class="check" src="../assets/ui/check.svg" alt=""> {{ t("Oui, veuillez m'envoyer des e-mails réguliers avec les nouveautés du SIVEC.")}}</label>
                </div>
                <div class="box__content__checkbox">
                    <input v-on:change="checkConditions" v-model="checked" type="checkbox" id="condition" required><label for="condition"><img class="check" src="../assets/ui/check.svg" alt=""> {{ t("J'ai lu et j'accepte le Règlement")}}</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const VueScrollTo = require('vue-scrollto');
    var cancelScroll;

    export default {
        name: 'Conditions',
        data: function () {
            return({
                newsletter: false,
                checked: false,
            })
        },
        methods: {
            checkNewsletter() {
                let v = this;
                  setTimeout(function () {
                      v.$store.commit('changeData', {
                      type: 'newsletter',
                      value: v.newsletter,
                  })
              }, 500);
            },
            checkConditions() {
                const v = this;
                setTimeout(function () {
                    if (v.checked) {
                        v.$store.commit('showSection', 'summarySection');

                        setTimeout(function () {
                            cancelScroll = VueScrollTo.scrollTo('#reservation', 1000, { onCancel: function() { cancelScroll(); } });
                        }, 500);
                    } else {
                        v.$store.commit('hideSection', 'summarySection');
                    }
                }, 50)
            }
        }
    }
</script>

<style scoped>
    .container {
        display: grid;
        gap: 20px;
        grid-template-columns: repeat(auto-fill, minmax(500px, 1fr));
        color: var(--green--dark);
        margin-bottom: 100px;
    }

    @media only screen and (max-width: 500px) {
        .container {
            grid-template-columns: 1fr;
        }
    }

    h2 {
        margin-top: 0;
    }

    h2 span {
        font-family: gill-sans-nova, sans-serif;
        font-weight: 700;
        font-size: 24px;
    }

    @media only screen and (max-width: 500px) {
        h2 span {
            display: block;
            margin-bottom: 10px;
        }
    }

    ol {
        list-style: none;
    }

    li {
        position: relative;
        padding: 8px 0 8px 10px;
        counter-increment: section;
    }

    li::before {
        content: "";
        background-color: var(--green--light);
        border-radius: 50%;
        height: 26px;
        position: absolute;
        top: 6px;
        left: -28px;
        width: 26px;
        z-index: -1;
    }

    li::after {
        content: counter(section) ".";
        font-size: 14px;
        position: absolute;
        top: 10px;
        left: -20px;
    }

    .box {
        border-top-left-radius: 30px;
        box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.17);
        display: flex;
        margin: var(--xxlarge) 0 var(--xlarge);
        overflow: hidden;
    }

    @media only screen and (max-width: 500px) {
        .box {
            margin: var(--xlarge) 0 var(--large);
        }
    }

    .box__highlight {
        background-color: var(--orange);
        border-bottom-right-radius: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: montserrat,sans-serif;
        font-weight: 700;
        font-size: 64px;
        min-width: 52px;
        color: white;
    }

    h2 {
        color: var(--green--dark);
        font-family: gill-sans-nova, sans-serif;
        font-size: 26px;
        font-weight: 700;
        margin-top: 0;
    }

    .box__content {
        background-color: white;
        padding: var(--xmedium);
        position: relative;
    }

    .box__content__checkbox{
        position: relative;
    }

    @media only screen and (max-width: 500px) {
        .box__content {
            padding: var(--xmedium) var(--medium);
        }
    }

    a {
        color: var(--green);
        display: block;
        font-size: 20px;
        text-decoration: underline;
        margin-bottom: 20px;
    }

    label {
        padding: 5px 0 15px;
        color: var(--grey);
        display: inline-flex;
        align-items: center;
        position: relative;
    }

    label:hover {
        cursor: pointer;
    }

    label::before {
        content: "";
        background-color: white;
        border: 2px solid var(--green);
        border-radius: 50%;
        display: inline;
        height: 24px;
        margin-right: var(--medium);
        position: relative;
        min-width: 24px;
    }

    input {
        position: absolute;
        bottom: 50px;
        left: 36px;
        opacity: 0;
    }

    input:focus + label::before {
        box-shadow: 0px 0px 2px 4px var(--green--light);
    }

    .check {
        position: absolute;
        left: 0;
        visibility: hidden;
    }

    input:checked + label .check {
        visibility: visible;
    }

</style>
